const translations = {
    all: 'Select All',
    deleteError: 'Unable to delete flight report at this time',
    none: 'Deselect All',
    numberSelected: '({{selected}}/{{total}} Selected)'
};

export default translations;
